import React from 'react';
import { Link } from 'gatsby';

export default function NavItemFooter(props) {
  return (
    <Link
      to={props.to}
      className="block text-white no-underline text-md md:text-sm lg:px-1 xl:px-3"
      activeClassName="border-b border-avenue-blue-500 pb-2"
    >
      {props.title}
    </Link>
  );
}
